import AdaptiveImage from "../../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "a67bc02341bab9b8cb03a02dd54503c6.png","uri@2x": __webpack_public_path__ + "a67bc02341bab9b8cb03a02dd54503c6.png","uri@3x": __webpack_public_path__ + "9f0898b513720066cd7d7214305348f1.png",
    width: 488,
    height: 83
});